import { PreviewPageComponent } from './app/pages/preview/preview-page.component';
import { provideTemplateRenderer } from './app/providers/template-renderer-config';
import { TEMPLATE_ROUTES } from './template-routes';

export const ROUTES = [
  {
    path: '',
    component: PreviewPageComponent,
  },
  {
    path: 'preview/:mode/:name/:index',
    component: PreviewPageComponent,
  },
  {
    path: 'mailgun',
    providers: [
      provideTemplateRenderer({
        interpolate: false,
      }),
    ],
    children: TEMPLATE_ROUTES,
  },
  {
    path: 'interpolate',
    providers: [
      provideTemplateRenderer({
        interpolate: true,
      }),
    ],
    children: TEMPLATE_ROUTES,
  },
];
